<template>
    <Modal id="ticket_finalizar" :open="show" customSizeWid="width:700px;margin: 0 auto;padding-top:10px" :FooterDefault="false" :ClassBG="true" customModalBody="min-height: calc(100vh - 15rem);" :customModalMain="'z-index:100000'">
        <template v-slot:header>
            <h6 class="modal-title">Finalizar Ticket</h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">
                <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
            </button>
        </template>
        <template v-slot:body>
            <p class="text-danger">
                <b>Atenção!</b> <br><br> <strong>Você está prestes a encerrar este ticket. Por favor, esteja ciente de que esta ação é final e irreversível. Uma vez encerrado, não será possível reabri-lo ou retomar seu estado anterior.</strong>
            </p>
            <Form ref="Form_OcorrenciaFinalizar" @submit="submit_Form_OcorrenciaFinalizar">
                <div class="row mt-3">
                    <div class="col">
                        <label class="form-label">Motivo</label>
                        <select class="form-select" v-model="OcorrenciaFinalizarCrud.idOcorrenciaMotivoFinalizacao" style="background-color:white;">
                            <option value="0">Selecione</option>
                            <option v-for="motivo in motivos" :key="motivo.idOcorrenciaMotivoFinalizacao" :value="motivo.idOcorrenciaMotivoFinalizacao">{{ motivo.dsMotivo }}</option>
                        </select>
                        <ErrorMessage name="dsMotivo" class="form-error" v-show="showErrorMessage" />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <label class="form-label">Descreva o Motivo</label>
                        <textarea id="dsMotivo" class="form-control shadow-v2" rows="3" :class="{ filled: OcorrenciaFinalizarCrud.dsMotivo }" v-model="OcorrenciaFinalizarCrud.dsMotivo" required />
                        <ErrorMessage name="dsMotivo" class="form-error" v-show="showErrorMessage" />
                    </div>
                </div>
            </Form>
        </template>
        <template v-slot:footer>
            <div class="modal-footer">
                <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal">
                    Fechar
                </button>
                <button type="button" class="btn btn-red-v2" @click="submit_Form_OcorrenciaFinalizar">
                    <i class="fas fa-stamp pe-2"></i>
                    Finalizar
                </button>
            </div>
        </template>
    </Modal>
</template>

<script>

    import axios from "axios";
    import Modal from "@/components/App/Modal.vue";

    export default {
        name: "Transferir_Tickets",
        components: {
            Modal
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            idOcorrencia: {
                type: Number,
                default: 0
            },
            cdSetor: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                OcorrenciaFinalizarCrud: {
                    idOcorrencia: 0,
                    dsMotivo: '',
                    idOcorrenciaMotivoFinalizacao: 0
                },

                showErrorMessage: false,
                motivos: []
            };
        },
        methods: {
            reset() {
                this.OcorrenciaFinalizarCrud = {
                    idOcorrencia: 0,
                    dsMotivo: '',
                    idOcorrenciaMotivoFinalizacao: 0
                }
            },
            submit_Form_OcorrenciaFinalizar() {
                let $this = this;

                $this.OcorrenciaFinalizarCrud.idOcorrencia = $this.idOcorrencia;

                $this.$refs.Form_OcorrenciaFinalizar.validate()
                    .then(isValid => {
                        if (isValid.valid) {
                            axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/PostFinalizarTicket', $this.OcorrenciaFinalizarCrud, { headers: $this.$api.getTokenComercial() })
                                .then(function (response) {
                                    $this.$emit('fechou_ticket');
                                    $this.reset();
                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }

                                    $this.$toast.show('alert', msg, true);
                                });
                            $this.showErrorMessage = false;
                        } else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatorios';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });

            },
            getMotivosFinalizacao() {
                let $this = this;

                if ($this.cdSetor > 0) {
                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/OcorrenciaMotivoFinalizacao/Get/' + $this.cdSetor, {
                        headers: $this.$api.getTokenComercial()
                    }).then(response => {
                        $this.motivos = response.data.data;
                    });
                }
            },
        },
        mounted() {
            this.getMotivosFinalizacao();
        },
        watch: {
            show(new_value, old_value) { this.reset(); },
            cdSetor(new_value, old_value) { this.getMotivosFinalizacao(); },
        },
    };

</script>


<style scoped lang="scss">
</style>